// 低代码相关的暴露本地组件的外部引入文件

export default [
  // {
  //   cnName: "流程组件", // 选择流程时所展示的名称
  //   component: require("@/CommonDP/components/breadcrumb/breadcrumb.vue").default, // 使用的组件
  //   id: "flowComp" // id不可重复唯一标识
  // }
];
